// External Links Accessibility Fixes
document.addEventListener('DOMContentLoaded', () => {

  const excludedLinks = [];

  const isThirdParty = (url) => {
    try {
      const linkUrl = new URL(url, window.location.origin);

      // Ignore mailto, tel, javascript and hash links
      if (
        ['mailto:', 'tel:', 'javascript:'].includes(linkUrl.protocol) ||
        url.startsWith('#')
      ) {
        return false;
      }

      return linkUrl.hostname !== window.location.hostname;
    } catch (e) {
      return false;
    }
  };

  document.querySelectorAll('a[href]').forEach(link => {
    const href = link.getAttribute('href');

    if (!href || excludedLinks.includes(href) || !isThirdParty(href)) return;

    // Open external links in a new tab
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');

    // Build accessible name
    const existingLabel = link.getAttribute('aria-label');
    const linkText = existingLabel || link.textContent.trim();

    if (linkText) {
      link.setAttribute(
        'aria-label',
        `${linkText} Redirecting to a third-party website Opens in a new tab`
      );
    }

    // Handle linked images
    const img = link.querySelector('img');
    if (img) {
      const alt = img.getAttribute('alt')?.trim();

      if (alt) {
        img.setAttribute(
          'alt',
          `${alt} Redirecting to a third-party website Opens in a new tab`
        );
      }
    }
  });

});

////remove aria-aria-labelledby
setTimeout(function() {
  document.querySelectorAll('.card__heading a, .card__heading.h3 a, card__heading h3').forEach(function(link) {
    link.removeAttribute('aria-labelledby');
  });
}, 5000);

setTimeout(function() {
  document.querySelectorAll('.thumbnail.global-media-settings.global-media-settings--no-shadow', '.yotpo-widget-clear').forEach(function(el) {
    el.removeAttribute('aria-describedby');
  });
}, 5000);

///add aria-hidden="true" on all br tags

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('br').forEach(function(br) {
    br.setAttribute('aria-hidden', 'true');
  });
});

//remove aria-labelledby
setTimeout(() => {
  document.querySelectorAll('.card__heading.h3 a.full-unstyled-link').forEach(el => {
    el.removeAttribute('aria-labelledby');
  });
}, 1000); // 1-second delay

document.querySelectorAll("h2").forEach((h2) => {
  if (!h2.textContent.trim() && h2.children.length === 0) {
    h2.remove();
  }
});

document.addEventListener("DOMContentLoaded", () => {
  function replaceH4WithH2() {
    document
      .querySelectorAll("#iwish-drawer-root .iwish-drawer-menu .iwish-row div h4")
      .forEach((h4) => {
        // Skip if already replaced
        if (h4.dataset.headingReplaced) return;

        const h2 = document.createElement("h2");

        // Copy attributes
        [...h4.attributes].forEach((attr) => {
          h2.setAttribute(attr.name, attr.value);
        });

        // Preserve content
        h2.innerHTML = h4.innerHTML;

        // Mark as processed
        h2.dataset.headingReplaced = "true";

        // Replace
        h4.replaceWith(h2);
      });
  }

  // Run once in case the drawer already exists
  replaceH4WithH2();

  // Watch for dynamically added content
  const observer = new MutationObserver(() => {
    replaceH4WithH2();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});